import React from "react";
import "./Footer.css";
import { Twitter, Youtube, Linkedin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-grid">
        <div>
          <h4>#1 AI Video Model</h4>
          <p>Bump AI will watch any video and deliver insights across all industries.</p>
          <div className="socials">
            <Twitter /> <Youtube /> <Linkedin />
          </div>
        </div>

        <div>
          <h4>Product</h4>
          <a href="#">Workspaces</a>
          <a href="#">Pricing</a>
          <a href="#">Channels</a>
        </div>

        <div>
          <h4>Features</h4>
          <a href="#">Creator Studio</a>
          <a href="#">YouTube Videos</a>
          <a href="#">Analytics</a>
        </div>

        <div>
          <h4>API</h4>
          <a href="#">Startups</a>
          <a href="#">Zapier</a>
          <a href="#">Enterprise</a>
        </div>
      </div>
    </footer>
  );
}
